import { DeliveryDTO } from '../../../../Domain/DTO/DeliveryDTO';
import { UserDTO } from '../../../../Domain/DTO/UserDTO';
import { EDeliveryState } from '../../../../Domain/Enum/EDeliveryState';
import { AuthenticationService } from '../../../../Infrastructure/Services/AuthService';
import { StatusDefault } from '../../../../Infrastructure/Status/StatusDefault';
import { DeliveryWithdrawAction } from '../Actions/DeliveryWithdrawAction';
import { MarkAsDeliveredAction } from '../Actions/MarkAsDeliveredAction';
import { SynchronizeDeliveryAction } from '../Actions/SynchronizeDeliveryAction';
import { UpdateVehicleDriverAction } from '../Actions/UpdateVehicleDriverAction';
import { DeliveryHelperProps } from '../IHelperProps';
import { WaitingDelivery } from './WaitingDelivery';


export class Delivery extends StatusDefault<DeliveryDTO, DeliveryHelperProps>{
    public TitleCurrent : string = "delivery:StatusDeliveryCurrent";
    public TitleFinished: string = "delivery:StatusDeliveryFinished";
    public TitleFuture  : string = "delivery:StatusDeliveryFuture";

    public IsActive(dto: DeliveryDTO) {
        return true;
    }

    public IsCurrent(dto: DeliveryDTO){
        return dto.State === EDeliveryState.WaitForLoading ||
            dto.State === EDeliveryState.VehicleArrivedAtLoadingPoint ||
            dto.State === EDeliveryState.VehicleArrivedAtUnloadingPoint  ||
            dto.State === EDeliveryState.LatenessRegistration ||
            dto.State === EDeliveryState.LoadingBegin ||
            dto.State === EDeliveryState.LoadingEnd ||
            dto.State === EDeliveryState.Delivery;
    }

    public IsFinished(dto: DeliveryDTO){
        return !this.IsCurrent(dto) && new WaitingDelivery().IsFinished(dto);
    }

    public GetActions(dto: DeliveryDTO, currentUser: UserDTO, authService: AuthenticationService){
        return [new UpdateVehicleDriverAction<DeliveryHelperProps>(), new DeliveryWithdrawAction<DeliveryHelperProps>(),
            new MarkAsDeliveredAction<DeliveryHelperProps>(), new SynchronizeDeliveryAction<DeliveryHelperProps>()];
    }

    public GetTimeLeftInStatus(dto: DeliveryDTO): Date {
        if (dto.NextStateDate !== undefined && dto.NextStateDate !== null)
            return dto.NextStateDate;
        return undefined;
    }

}
